import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Background } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import classNames from 'classnames';
import { meta } from '../../meta';

export type PopupProps = PropsWithChildren<{ show: boolean }>;

export const Popup = ({ show, children }: PopupProps) => {
  const { overlayBackground, image, renderThumbnailMode } = useSettings();
  const {
    type,
    color,
    gradient,
    imageFile,
    imageBrightness,
    videoUrl,
    videoScale,
    videoBrightness
  } = overlayBackground;

  let videoPreviewUrl;
  if (videoUrl?.id && videoUrl?.type) {
    videoPreviewUrl = {
      youtube: `https://i.ytimg.com/vi/${videoUrl.id}/maxresdefault.jpg`,
      vimeo: `https://vumbnail.com/${videoUrl.id}.jpg`
    }[videoUrl.type];
  }

  let finallyType = type;
  let finallyImageFile = imageFile;
  if (renderThumbnailMode && videoPreviewUrl && type === 'video') {
    finallyType = 'image';
    finallyImageFile = {
      url: videoPreviewUrl
    };
  }

  return (
    <Container _show={show}>
      <Background
        type={finallyType}
        color={color}
        gradient={gradient}
        imageFile={finallyImageFile}
        imageBrightness={imageBrightness}
        videoUrl={videoUrl}
        videoScale={videoScale}
        videoBrightness={videoBrightness}
        style={{ position: 'fixed' }}
      />

      <Inner onClick={(e) => e.stopPropagation()} _hasImage={!!image}>
        {children}
      </Inner>
    </Container>
  );
};

const Container = styled.div.attrs(({ _show }) => ({
  className: classNames(`${meta.prefix}-popup-container`, {
    [`${meta.prefix}-popup-show`]: _show
  })
}))`
  position: fixed;
  inset: 0;
  display: ${({ _show }) => (_show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  background-position: center;
  background-size: cover;
  z-index: 2147483638;

  &:after {
    inset: 0;
    content: '';
    display: block;
    position: absolute;
    background-color: transparent;
    z-index: 1;
  }
`;

const Inner = styled.div.attrs({
  className: `${meta.prefix}-popup-inner`
})`
  max-width: 920px;
  border-radius: 10px;
  position: relative;
  box-sizing: border-box;
  z-index: 2;
  min-height: 400px;
  display: flex;
  margin: 0 20px;
  width: ${({ _hasImage }) => (_hasImage ? '100%' : 'auto')};
`;
